var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplerAuditing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1583.645 -1679.355 145.34 145.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0078d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_14_1",
    "data-name": "Symbol 14 \\u2013 1",
    transform: "translate(28 -2725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(1555.645 1045.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M140.713,119.565,103.725,85.557a6.716,6.716,0,0,0-9.254.341l-1.987,1.987-5.621-5.649A48.959,48.959,0,0,0,99.1,49.535,49.549,49.549,0,1,0,49.535,99.07a50.386,50.386,0,0,0,24.782-6.614,3.405,3.405,0,1,0-3.293-5.961,44.34,44.34,0,0,1-21.46,5.621A42.36,42.36,0,0,1,6.614,49.506a42.935,42.935,0,0,1,85.87.057A42.378,42.378,0,0,1,80.249,79.625a3.027,3.027,0,0,0-.994,2.3v.653a2.984,2.984,0,0,0,.994,2.3l7.608,7.608L85.87,94.471a6.716,6.716,0,0,0-.341,9.254l34.036,36.988a14.43,14.43,0,0,0,10.9,4.627,14.817,14.817,0,0,0,14.875-14.875A15.559,15.559,0,0,0,140.713,119.565Zm-10.248,19.161a7.719,7.719,0,0,1-5.933-2.64L90.5,99.1l8.6-8.6,36.988,34.036a8.274,8.274,0,0,1,2.64,5.933A8.179,8.179,0,0,1,130.465,138.726Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(1568.844 1058.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M82.835,46.5A36.335,36.335,0,1,0,119.17,82.835,36.224,36.224,0,0,0,82.835,46.5Zm0,66.084a29.735,29.735,0,1,1,29.721-29.749A29.585,29.585,0,0,1,82.835,112.584Z",
    transform: "translate(-46.5 -46.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplerAuditing);
export default __webpack_public_path__ + "static/media/simpler-auditing.79b837e484f0a0d60f997745034899ed.svg";
export { ForwardRef as ReactComponent };